import React, { useState } from "react";
import { Redirect, Link } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import PageTitle from "../../layouts/PageTitle";
import Toast from "../toast/SetToast";
import AnnualMaskNodeSenderConfig from "./AnnualMaskNodeSenderConfig";

const EmailSenderSettings = () => {
  const { currentUser } = useAuth();
  const [workflow, setWorkflow] = useState("annual-mask");
  const roles = currentUser && Array.isArray(currentUser.roles) ? currentUser.roles : [];
  if (!roles.includes("super_admin")) return <Redirect to="/" />;

  return <>
    <Toast />
    <PageTitle activeMenu="Email Sender Settings" motherMenu="Admin" />
    <p className="text-muted">
      Set sender addresses separately for each workflow. Manage purchase notifications and order access in <Link to="/annual-mask-access">Annual Mask Access</Link>.
    </p>
    <Tabs id="email-sender-workflows" activeKey={workflow} onSelect={setWorkflow} className="mb-3" transition={false} mountOnEnter unmountOnExit>
      <Tab eventKey="annual-mask" title="CPAP Follow-Up — Annual Mask">
        <AnnualMaskNodeSenderConfig workflow="annual-mask" />
      </Tab>
      <Tab eventKey="booking" title="Booking Calendar — Doctor Emails">
        <AnnualMaskNodeSenderConfig workflow="booking" />
      </Tab>
    </Tabs>
  </>;
};

export default EmailSenderSettings;
